import { type ReactElement } from 'react'
import { TSection, type TSectionProps } from './TSection'

type Props = TSectionProps
export const TSectionList = (props: Props): ReactElement => {
  return (
    <TSection
      {...props}
      contentProps={{ ...props.contentProps, style: { padding: 0, gap: 0, ...props.contentProps?.style } }}
    />
  )
}
